import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav'
import { PageEvent, MatSnackBar } from '@angular/material';
import * as Rx from 'rxjs/Rx';
import { SessionService } from '../../service/session/session.module';
import { LoadingService } from '../../directive/loading/loading.module';

@Component({
  selector: 'app-owner-expense-record',
  templateUrl: './owner-expense-record.component.html',
  styleUrls: ['./owner-expense-record.component.css']
})
export class OwnerExpenseRecordComponent implements OnInit {
  @ViewChild('drawer', { static: false }) drawerCtrl: MatDrawer;
  expenseRecordMin = {
    main:{
      open:false
    },
    system: {
      company: {
        main: {
          uuid: ''
        }
      }
    },
    max: 10,
    offset: 0,
    filter: {
      name: '',
      value: ''
    }
  }
  paginatorModel = {
    total: 0,
    pageSizeOptions: [2, 5, 10, 25, 100, 200, 500, 1000],
  };
  // MatPaginator Output
  pageEvent: PageEvent;
  metadata = {
    searchBoxInput: new Rx.Subject<string>(),
    object: {
      main: {
        uuid: ''
      }
    }
  }
  expenseRecordList = [];

  constructor(private session: SessionService, public loadingService: LoadingService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.getExpenseRecordList();
  }

  /**Obtenemos la lista de clasificaciones de gasto***/
  getExpenseRecordList() {
    this.loadingService.wait();
    this.expenseRecordList = [];
    // verificamos en que pagina verificamos
    this.expenseRecordMin.system.company.main.uuid = this.session.getSessionObject().main.uuid;
    this.session.getRequest("pettyCash:findAllByCompany", this.expenseRecordMin).subscribe(
      (data: any) => {
        this.expenseRecordList = data.object.instanceList;
        this.paginatorModel.total = data.object.total;
        this.loadingService.hide();
      },
      error => {
        console.log("pettyCash:findAllByCompany", error);
        this.loadingService.hide();
      }
    );
  }

  // funcion para obtener los datos del paginado.
  onPaginateChange(event) {
    this.expenseRecordMin.offset = (event.pageIndex * event.pageSize);
    this.expenseRecordMin.max = event.pageSize;
    this.getExpenseRecordList();
  }

  handleUpdated(event) {
    this.expenseRecordMin.offset = (this.pageEvent ? this.pageEvent.pageIndex * this.pageEvent.pageSize : this.expenseRecordMin.offset);
    this.getExpenseRecordList();
  }

  tabChange(ev){
    switch(ev.index){
      case 0:
        this.expenseRecordMin.main.open = false;
      break;
      case 1:
      this.expenseRecordMin.main.open = true;
      break;
    }
    this.getExpenseRecordList();

  }

  /* funcionalidad para cambiar el menú
  */
  toogleMenu(ev) {
    this.drawerCtrl.opened = ev;
  }

}
